import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import AccessRestrictedContent from "../common_components/AccessRestrictedContent";
export default function NotFound() {
    return (_jsx(Box, { sx: {
            minHeight: "calc(100vh - 200px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }, children: _jsx(AccessRestrictedContent, {}) }));
}
